import classnames from "classnames";

export interface FieldLabelProps {
  className?: string;
  description?: string;
  field: string;
  label: string;
}

export const FieldLabel = ({
  field,
  label,
  description,
  className,
}: FieldLabelProps) => (
  <div className={classnames("form-meta", className)}>
    <label htmlFor={field}>{label}</label>
    {description && (
      <div
        className="field-description"
        dangerouslySetInnerHTML={{ __html: description }}
      ></div>
    )}
  </div>
);
